import { Highlight as MantineHighlight } from "@mantine/core";
import { polymorphicComponentWrapper } from "../../utilities";
import styles from "./highlight.module.scss";
import type { CustomHighlightFactory, IProps } from "./highlight.types";

/**
 * Renders highlighted text
 * @returns {JSX.Element} The Highlight component.
 */
const Highlight = polymorphicComponentWrapper<CustomHighlightFactory, IProps>("Highlight", (props, ref) => {
    return <MantineHighlight ref={ref} classNames={{ root: styles["root"] }} {...props} />;
});

export { Highlight };
